export default __webpack_public_path__ + "static/media/anillo.e13a46f5.png";